import React, { useState } from "react";
import CommonPaginationSection from "../../components/common/CommonPaginationSection";

function MilesPointsLogSection() {
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
    total: 10,
  });
  return (
    <div className="flex flex-col w-full">
      <div className="w-full flex flex-col gap-2">
        {/* Header */}
        <div className="w-full p-4 flex items-center bg-[#F0F6FC] gap-2">
          <div className="w-44 ">
            <small>DATE</small>
          </div>
          <div className="flex flex-1 ">
            <small>ACTIVITY</small>
          </div>
          <div className="w-44 ">
            <small>TYPE</small>
          </div>
          <div className="w-44 ">
            <small>STATUS</small>
          </div>
          <div className="w-44 ">
            <small>POINT</small>
          </div>
        </div>
        {[...Array(10)].map((_, index) => (
          <div
            className="w-full p-4 flex items-center bg-white gap-2"
            key={index}
          >
            <div className="w-44 flex flex-col">
              <small>
                12:54<small className="text-primary1">pm</small>{" "}
              </small>
              <small>22/03/2023</small>
            </div>
            <div className="flex flex-1 ">
              <small>Daily Check-in (Day 3 Streak)</small>
            </div>
            <div className="w-44 ">
              <LogType value="Earned" />
            </div>
            <div className="w-44 ">
              <Status status="booked" />
            </div>
            <div className="w-44 ">
              <small>50</small>
            </div>
          </div>
        ))}
      </div>
      <CommonPaginationSection
        page={pagination.page}
        perPage={pagination.perPage}
        total={pagination.total}
        callback={(page, perPage) => {
          setPagination({
            ...pagination,
            page,
            perPage,
          });
        }}
      />
    </div>
  );
}

const LogType = ({ value }) => {
  const PrefixElement = () => {
    if (value === "Earned") {
      return (
        <div className="w-3 h-3 rounded-full bg-[#0B662C] flex shrink-0"></div>
      );
    } else {
      return (
        <div className="w-3 h-3 rounded-full bg-[#B81F25] flex shrink-0"></div>
      );
    }
  };
  return (
    <div className="flex gap-2 items-center">
      <PrefixElement />
      <span className="text-sm">{value}</span>
    </div>
  );
};

const Status = ({ status }) => {
  const statusStyle = () => {
    switch (status) {
      case "booked":
        return "bg-[#009688]/10 text-[#009688]";
      case "registered":
        return "bg-[#1E61DC]/10 text-[#1E61DC]";
      default:
        return "bg-[#1E61DC]/10 text-[#1E61DC]";
    }
  };
  return (
    <div
      className={`text-sm px-2 py-[6px] w-fit rounded-md font-semibold ${statusStyle()}`}
    >
      {status}
    </div>
  );
};

export default MilesPointsLogSection;
